import { measurementToViewport } from 'utils/placement';
import { TemplateAction } from '../../action-types';
import { VideoTemplateStateContent } from '../../types';
import {
  resetSoundwave,
  setSoundwave,
  setSoundwaveColor,
  setSoundwaveDimensions,
  setSoundwavePlacement,
  setSoundwaveType,
  setWaveformFidelity,
} from './mutations';

export default function reducer(
  state: VideoTemplateStateContent,
  action: TemplateAction,
): VideoTemplateStateContent {
  switch (action.type) {
    case 'SOUNDWAVE_COLOR_CHANGE':
      return setSoundwaveColor(state, action.payload);

    case 'SOUNDWAVE_TYPE_CHANGE':
      return setSoundwaveType(state, action.payload);

    case 'SOUNDWAVE_DIMENSIONS_CHANGE': {
      const {
        payload: { height, width, left, top },
      } = action;
      const { canvas } = state;
      return setSoundwaveDimensions(
        state,
        measurementToViewport(
          {
            height,
            left,
            top,
            width,
          },
          canvas,
        ),
      );
    }

    case 'SOUNDWAVE_FIDELITY_CHANGE': {
      return setWaveformFidelity(state, action.payload);
    }

    case 'SOUNDWAVE_PLACEMENT_SELECT': {
      return setSoundwavePlacement(state, action.payload);
    }

    case 'SOUNDWAVE_RESET': {
      return resetSoundwave(state);
    }

    case 'SOUNDWAVE_PRESET_SELECT': {
      return setSoundwave(state, action.payload);
    }

    default:
      return state;
  }
}
